export default Object.freeze({
  /// ---------------------------- Menu Bar ------------------------- 
  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscópio",
  BAR_GRAPH: "Gráfico de barras",
  REPORT: "Relatório",
  INFOS: "Agenda",
  RESUME: "Resumo",
  LOG: "Log",
  CONFIG: "Configurações",

  SAVE: "Salvar",
  REMOVE: "Remover",

  // ---------------------------- Live List ----------------------------
  TIME_ON: "Tempo de análise: ",

  GOOD_STRING: "Bom",
  ATTENTION_STRING: "Atenção",
  BAD_STRING: "Ruim",
  NO_SIGNAL_STRING: "Sem sinal",
  UNKNOWN_STRING: "Desconhecido",

  REASON: "\nMotivo: ",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço ou sinal",

  ADDRESSES: "Endereços",
  ADDRESS: "Endereço",
  AMPLITUDE: "Amplitude",
  AMPLITUDE_PRE: "Amplitude preâmbulo",
  MEAN_AMPLITUDE: "Amplitude média",
  MEAN_AMPLITUDE_N: "Amplitude\nmédia",
  MIN_AMPLITUDE: "Amplitude mínima",
  MIN_AMPLITUDE_N: "Amplitude\nmínima",
  MAX_AMPLITUDE: "Sobressinal",
  NOISE: "Ruído",
  SIGNAL: "Sinal",
  RATIO: "Razão",
  NETWORK_TAG: "Tag do segmento",
  IS_IN_SEGMENT: "Pertence ao\nSegmento?",
  IS_IN_SEGMENT_1: "Pertence ao",
  IS_IN_SEGMENT_2: "Segmento?",
  IS_IN_SEGMENT_DP: "Pertence ao Segmento: ",
  IS_IN_SEGMENT_QUESTION: "Pertence ao Segmento?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indica se o dispositivo pertence ao mesmo segmento que este TS Scope DP.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "Esta opção deve ser ajustada manualmente para cada dispositivo na tela de configurações.",

  MIN_AMPLITUDE_1: "Amplitude",
  MIN_AMPLITUDE_2: "mínima",

  MEAN_AMPLITUDE_1: "Amplitude",
  MEAN_AMPLITUDE_2: "média",

  RESPONSE_TIME_1: "Tempo de",
  RESPONSE_TIME_2: "resposta",
  CURRENT: "atual",
  MINIMUM: "mínimo",
  MAXIMUM: "máximo",

  RESPONSE_TIME: "Tempo de\nresposta\natual",
  MIN_RESPONSE_TIME: "Tempo de\nresposta\nmínimo",
  MAX_RESPONSE_TIME: "Tempo de\nresposta\nmáximo",

  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "Esta coluna é um indicador de problemas no canal A, fio verde, tais como:",
  CHANNEL_B_PROBLEM: "Esta coluna é um indicador de problemas no canal B, fio vermelho, tais como:",
  MASTERS: "Mestres",
  SLAVES: "Escravos",
  AMPLITUDE_IDLE: "Tensão no idle ",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  NETWORK_DATA: "Dados da rede",

  MODAL_TITLE: "Formas de onda caracteristicas",

  TURNED_ON: "Ligada",
  TURNED_OFF: "Desligada",

  ANALYSIS_ERROR: "Ocorreu um erro ao alterar o estado da análise",

  ANALYSIS: "Análise",
  ANALYZER: "TS Scope DP ",

  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "TS Scope DP não encontrado, por favor conecte-o ao computador.",
  INVERTED_AB: "Os cabos A e B estão invertidos.",
  MONGO_OFF: "Erro na base de dados, feche o programa e abra novamente. Se o erro persistir clique no botão abaixo.",
  PICO_NOT_FOUND: "O TS Scope DP está desconectado. Após reconectá-lo, é necessário reiniciar o programar.",
  MONGO_REPAIR_SUCCESS: "Erro reparado com sucesso! Por favor feche o programa e abra novamento para que as alterações tenham efeito.",
  MONGO_REPAIR_ERROR: "Não foi possível solucionar o problema. Por favor entre em contato para receber suporte.",
  INIT_PICO_NOT_FOUND_PLAY: "Erro ao iniciar o TS Scope DP. Por favor desconecte-o do seu computador, conecte novamente, e reinicie o programa. Caso o erro persista, reinicie o computador e tente novamente.",

  REPAIR: "Reparar",
  LOADING_ANALYZER: "Iniciando TS Scope DP, por favor aguarde.",

  NO_DP_ACTIVE_NETWORK: "O TS Scope DP não encontrou uma rede ativa, certifique-se de que está conectado corretamente a uma rede PROFIBUS DP e tente novamente.",

  INVALID_SERIAL: "O número de série não corresponde a este TS Scope DP. Por favor reinstale o programa com um número de série válido.",
  INVERTED_AB_POPUP: "Os cabos A e B estão invertidos.\nPor favor desinverta os cabos e aperte Play novamente.",

  MONGO_OFF_POPUP: "Erro ao inicializar a base de dados, clique no botão abaixo para reparar o problema.",

  MEAN_AMPLITUDE_DESC: "Valor de amplitude medido entre a média dos pontos em nível lógico alto e a média dos pontos em nível lógico baixo, como ilustra a figura abaixo.",
  MEAN_AMPLITUDE_DESC_2: "A amplitude média alta é um indicativo de falta de terminadores. Já quando esta baixa indica: Resistência nas conexões; excesso de terminadores; cabos prensados; cabos amassados ou dobrados etc.",
  AMPLITUDE_MIN_DESC: "Valor de amplitude entre o menor ponto da forma de onda em nível lógico alto e o maior ponto em nível lógico baixo, como ilustra a figura abaixo.",
  AMPLITUDE_MIN_DESC_2: "Uma diferença grande entre a amplitude média e a mínima indica: Reflexão (terminadores); cabo longo; ruído; umidade no barramento etc.",
  OVERSHOOTING_DESC: "Valor de amplitude entre o valor médio da forma de onda em nível lógico alto e o maior ponto em nível lógico alto, como ilustra a figura abaixo.",
  OVERSHOOTING_DESC_2: "Indica: Falta de terminadores; conexões no meio do barramento; derivações etc.",
  RATIO_DESC_1: "Razão entre os valores de amplitude mínima e amplitude média, com o intuito de deixar evidente a degradação do sinal.",
  RATIO_DESC_2: "Quanto mais próximo de 1 melhor, e quanto mais próximo de 0 (zero) pior a qualidade do sinal.",
  RATIO_FOMULA: "Razão = Amp. mínima / Amp. média",

  IDLE_DESCRIPTION: " Período em que a rede está ociosa, ou seja, é o período entre uma pergunta do mestre e a resposta do escravo,  ou entre pacotes do mestre para ele mesmo. A tensão ideal do idle é de 1V, valores diferentes indicam problemas na rede.",

  MONITOR_IP_NOT_FOUND: "IP do monitor não encontrado",

  CHANNEL_DESCRIPTION_1: "Curto-circuito;",
  CHANNEL_DESCRIPTION_2: "Borne frouxo;",
  CHANNEL_DESCRIPTION_3: "Cabo rompido;",
  CHANNEL_DESCRIPTION_4: "Ou outro problema que danifique o sinal de comunicação.",

  SIGNAL_QUALITY: "Qualidade do sinal",
  SIGNAL_QUALITY_DESCRIPTION_1: "Na coluna “Sinal” sempre é considerado o pior caso, para Amplitude média e mínima.",

  GOOD: "Bom",
  GOOD_DESCRIPTION_1: "• Amplitude Média de 4 a 7 V",
  GOOD_DESCRIPTION_2: ". Sinal com boa amplitude!",

  ATTENTION: "Atenção - Ação preventiva",
  ATTENTION_DESCRIPTION_1: "• Amplitude média de 7 a 8 V",
  ATTENTION_DESCRIPTION_2: ". Pode indicar falta de terminadores.",
  ATTENTION_DESCRIPTION_3: "• Amplitude média de 3 a 4 V",
  ATTENTION_DESCRIPTION_4: ". Pode indicar resistência no barramento, muitos terminadores, problemas de conexão, bornes frouxos, problema em escravo etc.",

  BAD: "Ruim - Ação corretiva",

  BAD_DESCRIPTION_1: "• Amplitude média menor que 3 V",
  BAD_DESCRIPTION_2: " ou maior que 8 V",
  BAD_DESCRIPTION_3: ", pode causar perda de pacotes PROFIBUS.",
  BAD_DESCRIPTION_4: "• Amplitude mínima menor que 3 V",
  BAD_DESCRIPTION_5: " pode causar perda de pacotes PROFIBUS.",

  LIGHT_TONES: "Tons claros",
  LIGHT_TONES_DESCRIPTION: "• O TS Monitor PROFIBUS PRO não está encontrando resposta do escravo, portanto o software mantém as medições da última captura e deixa o tom claro indicando que não esta atualizando os dados.",


  IDLE: "Idle:",
  TENSAO_IDLE_POPUP_1: "Caso a tensão no idle seja menor que 0,6 V o valor será destacado em laranja.",
  TENSAO_IDLE_POPUP_2: "Somente aparecerão aqui as tensões no idle dos canais ativos. Para alterar quais canais estão ativos no momento vá até a seção 'CANAIS ATIVOS' na tela de configurações.",
  PS: "OBS",

  YEAR: " ano",
  MONTH: " mês",
  MONTHS: " mêses",
  DAY: " dia",
  HOUR: " hora",
  MINUTE: " minuto",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Gráfico",
  A_AND_B: "A e B",
  B_A: "B - A",
  WAVE_FORM: "Forma de onda",
  AMPLITUDE_A: "Amplitude A",
  AMPLITUDE_B: "Amplitude B",
  ADDRESS_DP: "Endereço: ",
  WAVE_A: "Sinal A",
  WAVE_B: "Sinal B",
  WAVE_B_A: "Sinal B - A",
  WAVE_PA: "Sinal DP",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Tempo (ns)",
  TIME_US: "Tempo (μs)",
  TIME_MS: "Tempo (ms)",
  TIME_S: "Tempo (s)",

  AMPLITUDE_PLACEHOLDER: "0.0 V",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tempo",
  CONTROLS_POPUP_TEXT: "Após apertar PLAY, a forma de onda é atualizada aproximadamente a cada 200 milissegundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar os controles é preciso selecionar a visualização manual e escolher um dispositivo.",

  SIZE: "Tamanho ",
  VISUALIZATION: "Visualização",
  AUTOMATIC: "Automática",
  MANUAL: "Manual",

  STD_WAVE_FORM: "Forma de onda padrão",
  LONG_CABLE_WAVE_FORM: "Forma de onda típica de cabo longo",
  EXCESS_TERMINATIOR_WAVE_FORM: "Forma de onda típica de excesso de terminador",
  NO_SLAVE_WAVE_FORM: "Forma de onda típica de ausência de escravo (dispositivos desconectados)",
  REFLECTION_WAVE_FORM: "Forma de onda típica com reflexão",
  NO_TERMINATOR_WAVE_FORM: "Forma de onda típica de falta de terminador",
  FOR_MORE_INFO_DP: "Para informações adicionais, consulte a Toledo & Souza ou as diretrizes da PROFIBUS International. Vale ressaltar que os eventos demonstrados podem acontecer em conjunto o que muda o padrões demonstrados.",
  FEW_TERMINATOR_WAVE_FORM: "Forma de onda típica de pouco terminador",

  WAVE_SIZE_DESC_1: "O TS Scope DP já amostra o frame de dois modos com apenas 1 Byte ou com 3 Bytes, de tal modo que aqui conseguimos visualizar com um zoom maior em 1 Byte ou um zoom menor em 3 Bytes.",
  WAVE_SIZE_DESC_2: "Existe uma exceção: O frame “E5” – short acknowledgement – só tem 1 Byte, sempre.",
  WAVE_SIZE_DESC_3: "Abaixo um exemplo em um frame com mais de 1 e 3 Bytes.",

  TS_SCOPE_NOT_FINDING_ANSWER: "O TS Scope DP não está encontrando resposta do escravo, portanto os dados estão desatualizados. A forma de onda abaixo é a última capturada pelo sistema.",

  TIME_DP: "Tempo: ",
  PS_1: "Obs 1:",
  PS_2: "Obs 2:",
  PS_3: "Obs 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Classificar por",
  AMPLITUDE_ASC: "Amplitude crescente",
  AMPLITUDE_DESC: "Amplitude decrescente",
  ADDRESS_ASC: "Endereço crescente",
  VOLTAGE_V: "Tensão (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensão (V)",
  VOLTAGE_MV: "Tensão (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Tensão (mV)",
  ORDER: "Ordenação",
  REFRESH_DATA: "Atualizar dados",
  LOADING: "Carregando",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Favor digite um tipo de evento válido.",
  BEFORE_MONITOR_INIT_STR: "Anterior à última inicialização",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por tipo de evento",
  LOG_WAITING: "Carregando dados do log",
  TYPE: "Tipo",

  TERMINATION_OFF_LOG_DESCRIPTION: "O TS Expert detectou uma possível falta de terminador na rede.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "O TS Expert detectou possível falta de alimentação no terminador.",
  HIGH_RESISTANCE_LOG_DESCRIPTION: "O TS Expert detectou um possível excesso de terminadores ou alta resistência no barramento PROFIBUS.",
  A_NOT_OK_LOG_DESCRIPTION: "O TS Expert detectou possível curto-circuito entre o condutor A e a malha de blindagem, ou a massa aterrada de um painel ou escravo.",
  B_NOT_OK_LOG_DESCRIPTION: "O TS Expert detectou possível curto-circuito entre o condutor B e a malha de blindagem, ou a massa aterrada de um painel ou escravo.",
  LONG_CABLE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de barramento com comprimento maior do que o permitido.",
  NOISE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de ruído na rede PROFIBUS.",
  REFLECTION_LOG_DESCRIPTION: "O TS Expert detectou a presença de reflexão na forma de onda.",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha no nível de tensão (Ação Requerida).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha no nível de tensão (Ação Urgente).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha por relé.",
  EVENT_CHECKED_SUCCESS: "O evento foi limpo com sucesso.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME: "Relatório TS Scope DP",
  HEADER_TEXT: "TS Scope DP",
  GENERATE_REPORT: "Gerar relatório",

  ANALYZER_VERSION_STRING: "- Versão do TS Scope DP:",
  ANALYZER_VERSION: "6.0.1",

  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "PROFIBUS DP",

  ANALYSIS_INIT: "- Horário de início da análise:",
  REPORT_GENERATION: "- Horário de geração do relatório:",
  ANALYSIS_DURATION: "Duração da análise até a geração do relatório:",

  GENERAL_REPORT: "Relatório geral – TS Scope DP",
  DATA_REPORT: "Relatório de dados – TS Scope DP",

  CLIENT_INFO: "Informações do cliente",
  EXECUTING_COMPANY_INFO: "Informações da empresa executora",
  CONFORMITY: "Conformidade",
  REPORT_TYPE: "Tipo de Relatório",
  ANNOTATIONS: "Anotações",
  CONCLUSION: "Conclusão",

  DROPDOWN_PLACEHOLDER: "Escolha uma opção",
  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme com restrições",
  NON_CONFORM: "Não conforme",

  PROJECT_NAME: "- Nome do projeto:",
  NETWORK_NAME: "- Nome da rede:",
  LOCATION: "- Localização:",
  COMPANY_NAME: "- Nome da empresa:",
  ACCOUNTABLE_NAME: "- Nome do responsável:",
  COMPANY_ADDRESS: "- Endereço:",
  COMPANY_CITY: "- Cidade:",
  COMPANY_TEL: "- Telefone:",

  EXECUTING_COMPANY_NAME: "- Nome da empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nome do responsável:",
  EXECUTING_TEL: "- Telefone:",
  EXECUTING_EMAIL: "- Email:",

  SUMMARY: "Sumário",

  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2. - Osciloscópio",
  A_BAR_GRAPH_PAGE_TITLE: "3. - Gráfico de barras",
  A_LOG_PAGE_TITLE: "4. - Log de eventos",

  ANALYSIS_INFO: "Informações da análise",
  GENERATED_BY: "- Gerado por TS Scope DP",
  HARDWARE_VERSION: "- Versão de hardware:",
  SOFTWARE_VERSION: "- Versão de software:",
  DATE_TIME: "- Data e hora:",
  BAUD_RATE: "- Baud rate:",
  CYCLE_TIME: "- Tempo de ciclo:",
  NUM_MASTERS: "- Mestres:",
  NUM_SLAVES: "- Escravos:",
  AMPLITUDE_IDLE_1: "- Tensão no idle:",
  SEGMENT_TAG: "- Tag do segmento:",

  ETHERNET_INFO: "Informações ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Nome da rede: ",

  LIVE_LIST_DOTS: "........................................................................................................................................",
  BAR_DOTS: ".........................................................................................................................",
  OSC_DOTS: "................................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  DISCLAIMER_DOTS: "....................................................................................................................................",

  GENERATING_REPORT_WAITING: "Gerando relatório, por favor aguarde.",
  GENERATING_REPORT_WAITING_1: "Este procedimento está demorando mais que o normal.",
  GENERATING_REPORT_WAITING_2: "Este procedimento está demorando mais que o normal, por favor continue aguardando.",
  GENERATING_REPORT_SUCCESS: "Relatório gerado com sucesso. Para salvá-lo, clique em salvar relatório abaixo.",

  SELECT_REPORT_TYPE: "Por favor selecione um tipo de relatório",

  MASTER_DP: "Mestre: ",
  SLAVE_DP: "Escravo: ",
  SIGNAL_DP: "Sinal: ",
  AMPLITUDE_DP: "Amplitude: ",
  AMPLITUDE_PRE_DP: "Amplitude preâmbulo: ",
  AMPLITUDE_MIN_DP: "Amplitude mínima: ",
  OVERSHOOTING_DP: "Sobressinal: ",
  AMPLITUDE_MAX_DP: "Amplitude máxima: ",
  MODEL: "Modelo",

  HORARY: "Horário",
  DESCRIPTION: "Descrição",
  GENERAL_INFORMATION: "Informações gerais",
  LAST_200_EVENTS: "200 últimos eventos",

  END_OF_REPORT: "Fim do relatório",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Os dados e valores apresentados neste relatório são meramente auxiliares para o especialista em PROFIBUS, de tal sorte que qualquer indicação de correção deve ser feita pelo usuário. Por esta razão, recomenda-se acompanhamento de engenheiro certificado PROFIBUS ou técnico responsável pela análise para atestar as informações prestadas pelo produto. Portanto a Toledo & Souza se exime de quaisquer responsabilidades, perdas ou danos, diretos ou indiretos causados pelas interpretações do software, não oferecendo nenhuma garantia em relação à integridade, qualidade ou adequação das informações prestadas, pois dependem da análise técnica de um profissional capacitado, sendo que na falta deste, o usuário assumirá o risco de que o conteúdo possa ser impreciso, incompleto ou possa não atender às suas necessidades e requisitos.",

  CAPTURE_TIME: "Horário da captura",

  PROJECT_NAME_LABEL: "Nome do projeto",
  NETWORK_LABEL: "Nome da rede",
  LOCATION_LABEL: "Localização",
  COMPANY_NAME_LABEL: "Nome da empresa",
  ACCOUNTABLE_NAME_LABEL: "Nome do responsável",
  CITY_LABEL: "Cidade",
  TEL_LABEL: "Telefone",
  CLIENT_LOGO_LABEL: "Logo do cliente",
  EMAIL_LABEL: "E-mail",
  EXECUTING_COMPANY_LOGO_LABEL: "Logo da empresa executora",
  FINISHING: "Finalizando...",
  SAVE_REPORT: "Salvar relatório",
  SLAVE_NOT_FOUND_SHOWING_LAST_WAVEFORM: "Não foi possível encontrar o escravo na rede, mostrando última forma de onda capturada.",
  REPORT_SCOPE_DP: "Relatório - TS Scope DP",
  MASTER: "Mestre ",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Entrar",
  LOGOUT: "Logout",
  TEST_NETWORK: "Rede de teste",
  TIMEZONE: "Timezone",
  RESTART_SYSTEM: "Reiniciar Sistema",
  IP: "IP",
  MASK: "Máscara",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  TAGS: "Tags",
  SETUP: "Configurar",
  EDIT: "Editar",
  SOFTWARE_UPDATE: "Atualização de Software",
  INTERFACE_CONFIG: "Configurações de Interface",
  CURRENT_VERSION: "Versão atual: ",
  UPDATE: "Atualizar",
  USER: "Usuário",
  NEW_PASSWORD: "Nova senha",
  REPEAT_PASSWORD: "Repetir senha",
  ALTER_LOGIN: "Alterar login",
  ARE_YOU_SURE_ALTER_CONFIG: "Tem certeza que deseja alterar as configurações Ethernet do TS Scope DP?",
  INVALID_OR_CORRUPT_FILE: "O arquivo não é válido ou está corrompido.",
  IMPORT: "Importar",
  EXPORT: "Exportar",
  LOGIN_CREDENTIALS_FAILURE: "Ocorreu um erro ao realizar o login: Nome de usuário ou senha incorretos.",
  LOGIN_GENERAL_FALIURE: "Ocorreu um erro ao realizar o login:",

  GPG_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .gpg",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "O arquivo foi enviado com sucesso.",
  SEND_FILE_SUCCESS_WARNING: "Não esqueça de verificar se a placa de rede do seu computador está na mesma subrede do IP: ",
  SEND_FILE_FAILURE: "Ocorreu um erro ao enviar o arquivo.",
  SEND_FILE_WAITING: "Enviando o arquivo.",
  SEND_FILE_WRONG_FILENAME: "Nome inválido. O arquivo de atualização deve chamar-se: updateRMDP.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "O arquivo de atualização foi corrompido durante o envio.",
  SEND_CONFIG_SUCCESS: "As configurações foram enviadas com sucesso.",
  SEND_CONFIG_FAILURE: "Ocorreu um erro ao enviar as configurações.",
  SEND_CONFIG_WAITING: "Enviando as configurações.",
  SEND_CONFIG_WAITING_2: "Finalizando envio das configurações.",
  SEND_CONFIG_DONE: "Configurações enviadas.",
  START_MESSAGE_SUCCESS: "O monitor irá iniciar em 15 segundos.",
  START_MESSAGE_FAILURE: "Ocorreu um erro ao iniciar o monitor.",
  STOP_MESSAGE_SUCCESS: "O monitor irá parar em 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocorreu um erro ao parar o monitor.",
  CLEAN_STATISTICS_SUCCESS: "As estatísticas foram limpadas com sucesso.",
  CLEAN_STATISTICS_FAILURE: "Ocorreu um erro ao limpar as estatísticas.",
  RESET_TRAFFIC_SUCCESS: "Os valores serão zerados na próxima varredura.",
  RESET_TRAFFIC_FAILURE: "Ocorreu um erro ao zerar os incrementos de erro.",
  RESET_DEVICES_SUCCESS: "Os dados de devices foram limpados com sucesso.",
  RESET_DEVICES_FAILURE: "Ocorreu um erro ao limpar os dados de devices.",
  CHANGE_USERNAME_SUCCESS: "O Nome de usuário foi alterado com sucesso. Por favor realize o login novamente.",
  CHANGE_USERNAME_FAILURE: "Ocorreu um erro ao alterar o nome de usuário: ",
  USERNAME_TOO_SHORT: "O nome de usuário precisa conter pelo menos um caractere.",
  PASSWORD_MISSMATCH: "As senhas digitadas não coincidem",
  CHANGE_PASSWORD_SUCCESS: "A senha foi alterada com sucesso. Por favor realize o login novamente.",
  CHANGE_PASSWORD_FAILURE: "Ocorreu um erro ao alterar a senha: ",
  RESET_RETRIES_SUCCESS: "As retentativas foram limpadas com sucesso.",
  RESET_RETRIES_FAILURE: "Ocorreu um erro ao limpar as retentativas.",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique as seguintes informações:",
  INVALID_IP: "\n- O IP inserido é inválido",
  INVALID_SUBMASK: "\n- A máscara inserida é inválida",
  INVALID_GATEWAY: "\n- O gateway inserido é inválido",
  INVALID_DNS: "\n- O DNS inserido é inválido",
  LOOPBACK_IP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do TS Scope DP",
  LOOPBACK_IP_NTP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do servidor NTP",
  TAG_TOO_LONG: "\n- O tamanho da tag não pode ultrapassar 30 caracteres",
  EMPTY_WIFI_PWD: "\n- A senha da Wi-fi não pode ser vazia",
  SELECT_TIMEZONE: "\n- É necessário selecionar uma Timezone para configurar o servidor NTP",
  SUBNET_OVERLAP_WLAN: "\n- O TS Scope DP detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a WLAN com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- O TS Scope DP detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a interface ETHERNET com o endereço IP e máscara escolhidos.",
  ZERO_IP_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como IP do TS Scope DP",
  ZERO_IP_MASK_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como máscara da rede",
  BROADCAST_IP_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do TS Scope DP",
  NETWORK_IP_MSG: "\n- O IP da rede não pode ser utilizado como IP do TS Scope DP",
  BROADCAST_GATEWAY_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do gateway",
  NETWORK_GATEWAY_MSG: "\n- O IP da rede não pode ser utilizado como IP do gateway",

  ALTER_USERNAME: "ALTERAR USUÁRIO",
  ALTER_PASSWORD: "ALTERAR SENHA",

  SYSTEM: "Sistema",
  RESTART: "Reiniciar",
  CONFIRM_RESTART_SYSTEM: "Tem certeza que deseja reiniciar o sistema?",
  RESTART_SYSTEM_FAILURE: "Ocorreu um erro ao tentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Pedido de reinicialização enviado com sucesso. Aguarde cerca de 3 minutos para que o sistema seja reiniciado completamente.",

  SELECT_FILE: "Por favor selecione um arquivo para ser enviado",
  SELECT_GSD_FLIE: "Por favor selecione ao menos um arquivo GSD para ser enviado",
  SENDING_GSD_FILES: "Enviando arquivos GSD",

  DO_NOT_CLOSE_THIS_TAB: "Deixe esta aba aberta para acompanhar a atualização.",
  UPDATING_MONITOR_FILES: "Atualizando arquivos no TS Scope DP. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Arquivos atualizados, preparando para reiniciar o TS Scope DP.",
  RESTARTING_MONITOR_WAIT: "Reiniciando o TS Scope DP, aguarde alguns minutos.",
  UPDATE_SUCCESS: "A atualização foi realizada com sucesso!",
  UPDATE_ERROR_STRING: "Ocorreu o seguinte erro ao atualizar o TS Scope DP: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique pelo menos um dos campos para atualizar as configurações de interface.",
  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• O IP do TS Scope DP foi modificado com sucesso.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• A observação foi modificada com sucesso.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nLembre-se de atualizar o endereço no navegador para: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "As configurações de interface foram atualizadas com sucesso!",

  ALTER: "Alterar",
  NO: "Não",
  YES: "Sim",

  NOTE: "Observação",
  MONITOR_IP: "IP do Monitor",

  IN_SEGMENT_DEVICES: "Dispositivos do segmento",
  UPDATING_DATA: "Atualizando informações, aguarde",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por endereço",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "Lista de dispositivos pertencentes ao mesmo segmento que o TS Scope DP.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "Se o dispositivo estiver desmarcado nesta lista, isto significa que ele não pertence ao mesmo segmento que o TS Scope DP.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "Se ele não pertencer ao mesmo segmento, a forma de onda vista no osciloscópio pode não corresponder à forma de onda real do dispositivo.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "Tem certeza que deseja realizar as alterações à lista de dispositivos pertencentes ao segmento?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "Ocorreu um erro ao alterar a lista de dispositivos do segmento.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "A lista de dispositivos do segmento foi alterada com sucesso!",

  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / desabilitar as não conformidades a serem informadas pela ferramenta.",

  SEND_NTP_CONFIG_WAITING: "Enviando as configurações do servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configurações do servidor NTP enviadas.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Ligar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "Tem certeza que deseja ligar o servidor NTP? Para isso o TS Scope DP precisará ser reiniciado.",

  PROCESSING_NTP_INIT: "Iniciando processamento das informações do servidor NTP",
  PROCESSING_NTP_INFO: "Processando as informações do servidor NTP.",
  PROCESSED_NTP_INFO: "Informações do servidor NTP processadas.",
  PROCESSING_NTP_ERROR: "Ocorreu um erro ao enviar as informações para o servidor NTP. Verifique se o endereço IP do servidor está correto. Caso estiver, verifique também se o serviço de NTP está ligado e tente novamente.",

  NTP_INFO_TURNED_ON_SUCCESS: "O servidor NTP foi ligado com sucesso.",
  NTP_INFO_TURNED_ON_FAILURE: "Ocorreu um erro ao ligar o servidor NTP.",
  NTP_INFO_FAILURE: "Falha ao sincronizar com o servidor. Caso o erro persista entre em contato com o administrador do servidor NTP.",
  TURN_ON_DATE: "\nO horário do servidor foi atualizado para: ",

  MONITOR_WILL_BE_RESTARTED: "\nO TS Scope DP será reiniciado agora,",
  MONITOR_RESTART_SUCCESS: "O TS Scope DP foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE: "Ocorreu um erro ao reiniciar o TS Scope DP.",

  NTP_INFO_TURNED_OFF_SUCCESS: "O servidor NTP foi desligado com sucesso.",
  NTP_INFO_TURNED_OFF_FAILURE: "Ocorreu um erro ao desligar o servidor NTP.",
  TURN_OFF_DATE: "\nHorário de desligamento: ",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuração da interface Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do TS Scope DP.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuração da interface sem fio, quando adaptador disponível.",
  WLAN_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do TS Scope DP.",

  TAG_CONFIG: "Tag do segmento",

  TAG_WAS_CHANGED_SUCCESSFULLY: "A tag do TS Scope DP foi modificada com sucesso.",
  TAG_CHANGE_FAILURE: "Ocorreu um erro ao modificar a tag do TS Scope DP.",

  INVALID_MONITOR_IP: "O IP do monitor inserido é inválido.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "O IP do monitor foi modificado com sucesso.",
  MONITOR_IP_CHANGE_FAILURE: "Ocorreu um erro ao modificar o IP do monitor.",

  WAITING: "Aguarde um instante",
  CLEAN_LOG_SUCCESS: "O log foi limpado com sucesso.",
  CLEAN_LOG_FAILURE: "Ocorreu um erro ao limpar o log.",
  CLEAR: "Limpar",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "Tem certeza que deseja alterar o hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "Para isso é necessário reiniciar o monitor.",
  HOSTNAME_POPUP_1: "Um hostname deve possuir entre 2 e 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Além disso, ele pode conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  INVALID_HOSTNAME_1: "O hostname deve possuir entre 2 e 64 caracteres.",
  INVALID_HOSTNAME_2: "O hostname deve conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  HOSTNAME_CONFIG_SUCCESS: "O hostname foi configurado com sucesso.",
  HOSTNAME_CONFIG_ERROR: "Ocorreu um erro ao configurar o hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",

  HOSTNAME: "Hostname",

  ALTER_MONITOR_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do TS Scope DP?",

  FIXED_IP: "IP Fixo",

  CHANGE_IDLE_SIZE: "Alterar tamanho do idle",
  CHANGE_IDLE_SIZE_QUESTION_1: "Alterar o tamanho do idle reiniciará os procedimentos internos do TS Monitor PROFIBUS PRO. Esse procedimento pode levar até 3 minutos.",
  CHANGE_IDLE_SIZE_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",

  CHANGE_PACKET_SIZE: "Alterar tamanho de pacote",
  CHANGE_PACKET_SIZE_QUESTION_1: "Alterar o tamanho de pacote reiniciará os procedimentos internos do TS Scope DP. Esse procedimento pode levar até 3 minutos.",
  CHANGE_PACKET_SIZE_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",

  ASK_PROCEED: "Tem certeza que deseja prosseguir?",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Adicionar/Alterar Tags",
  CHOOSE_DEVICE: "Escolha um dispositivo",
  NEW_TAG: "Nova TAG",
  REMOVE_ALL_TAGS: "Remover todas as Tags",
  CONFIRM_REMOVE_ALL_TAGS: "Tem certeza que deseja remover as tags de todos os dispositivos?",
  CHANGE_TAG_SUCCESS: "A tag foi alterada com sucesso.",
  CHANGE_TAG_FAILURE: "Ocorreu um erro ao alterar a tag",
  REMOVE_TAG_SUCCESS: "As tags foram removidas com sucesso.",
  REMOVE_TAG_FAILURE: "Ocorreu um erro ao remover as tags",
  IMPORT_TAGS_SUCCESS: "As tags foram importadas com sucesso",
  IMPORT_TAGS_FAILURE: "Ocorreu um erro ao importar as tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor selecione um arquivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Atualizando as configurações do TS Expert, aguarde um instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "As configurações do TS Expert foram salvas com sucesso.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorreu um erro ao salvar as configurações do TS Expert.",

  TS_EXPERT_CONFIGURATION: "Configurações do TS Expert",

  TERMINATION_OFF_LIST_HEADER: "Terminador na posição OFF",
  TERMINATION_OFF_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará possível falta de terminador na rede.",

  NO_POWER_SUPPLY_LIST_HEADER: "Terminador sem alimentação",
  NO_POWER_SUPPLY_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível falta de alimentação no terminador.",

  HIGH_RESISTANCE_LIST_HEADER: "Sinal atenuado",
  HIGH_RESISTANCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível excesso de terminadores ou alta resistência no barramento PROFIBUS.",

  A_NOT_OK_LIST_HEADER: "Curto entre o condutor A e a malha",
  A_NOT_OK_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível curto-circuito entre o condutor A e a malha de blindagem ou a massa aterrada de um painel ou escravo.",

  B_NOT_OK_LIST_HEADER: "Curto entre o condutor B e a malha",
  B_NOT_OK_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível curto-circuito entre o condutor B e a malha de blindagem ou a massa aterrada de um painel ou escravo.",

  LONG_CABLE_LIST_HEADER: "Cabo longo",
  LONG_CABLE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de barramento com comprimento maior do que o permitido.",

  NOISE_LIST_HEADER: "Ruído ou baixa isolação (fuga para terra)",
  NOISE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de ruído na rede PROFIBUS.",

  REFLECTION_LIST_HEADER: "Reflexão na forma de onda",
  REFLECTION_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará presença de reflexão na forma de onda.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Link de fibra ótica – Falha no nível de tensão (Ação Requerida)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará baixa tensão nas saídas analógicas que indicam a qualidade do sinal recebido pelo link de fibra. Este valor pode ser configurado pelo usuário na tela de configuração do seu TS Scope/Monitor PRO.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Link de fibra ótica – Falha no nível de tensão (Ação Urgente)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará baixa tensão nas saídas analógicas que indicam a qualidade do sinal recebido pelo link de fibra. Este valor pode ser configurado pelo usuário na tela de configuração do seu TS Scope/Monitor PRO.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Link de fibra ótica – Falha por relé",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "Quando ativada esta opção, o TS Expert mostrará falha no link de fibra indicada por relé, que deve estar conectado ao TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT: "Lista de ações",

  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de ações - TS Expert - TS Scope DP",

  TS_EXPERT_POPUP_1: "Nesta aba são apresentadas as informações do TS Expert.",
  TS_EXPERT_POPUP_2: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Scope DP em redes PROFIBUS.",
  TS_EXPERT_POPUP_3: "De forma automatizada, a manutenção, engenharia e equipes relacionadas podem obter uma lista de ações com diferentes eventos, suas possíveis causas, sugestões de solução e os dispositivos nos quais foram detectados.",
  TS_EXPERT_POPUP_4: "O uso do TS Expert não exclui a necessidade da análise humana e tampouco substitui tais capacidades de criar correlações de dados e interpretação.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado em: ",
  CHECK_YOUR_NETWORK: "Por favor verifique sua rede.",

  EXPORT_ACTIONS_LIST: "Exportar lista de ações",
  GENERATING_ACTIONS_LIST_WAITING: "Gerando PDF de lista de ações, por favor aguarde.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar lista de ações.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Ações",

  NO_PROBLEM_DETECTED: "O TS Expert não detectou nenhum evento na rede.",
  NO_EVENTS_TO_BE_ANALYZED: "Não existem eventos a serem analisados.",

  NO_EVENT_SELECTED: "Nenhum evento selecionado",
  CHOOSE_AN_EVENT: "Escolha um evento para visualizar as ações sugeridas.",

  DETAILING: "Detalhamento",

  CHECKED: "Limpar",
  BATCH_CHECK: "Limpar todos",

  PROBLEM_CHECKED: "O evento foi limpo com sucesso",
  PROBLEM_CHECK_ERROR: "Ocorreu um erro ao limpar o evento.",

  QUANTITY_DP: "Quantidade: ",
  INCREMENTS: "Incrementos",

  PORT_IS_STILL_INACTIVE: "A porta ainda está inativa",
  MARK_PROBLEM_AS_SOLVED: "Tem certeza que deseja marcar o evento como limpo?",

  LAST_UPDATED: "Atualizado pela última vez em: ",
  THIS_COMPUTER_TIME: " (Horário deste computador)",

  DEVICE: "Dispositivo",
  DEVICES: "Dispositivos",
  UNKNOWN: "Desconhecido",

  // ---------------------------- TERMINADOR OFF ----------------------------
  TERMINATION_OFF_SUGGESTION_1: "Quando o terminador estiver na posição OFF sugere-se:",
  TERMINATION_OFF_SUGGESTION_2: "Verificar visualmente:",
  TERMINATION_OFF_SUGGESTION_3: "Se os terminadores em ambas as extremidades do segmento estão na posição \"on\";",
  TERMINATION_OFF_SUGGESTION_4: "Se não forem utilizados conectores PROFIBUS, verificar se existe terminador ativo em ambas as extremidades;",
  TERMINATION_OFF_SUGGESTION_5: "Caso não exista terminador em uma das extremidades é necessário realizar a instalação.",
  TERMINATION_OFF_SUGGESTION_6: "Indica-se aguardar uma parada ou programar com a produção antes de ligar o terminador desligado ou instalar um terminador ativo, uma vez que esta alteração pode derrubar a rede.",

  // ---------------------------- NO POWER SUPPLY ----------------------------
  NO_POWER_SUPPLY_SUGGESTION_1: "Quando o terminador estiver sem alimentação sugere-se:",
  NO_POWER_SUPPLY_SUGGESTION_2: "Verificar a alimentação dos terminadores ativos (quando temos instalado o dispositivo) e verificar a alimentação para terminadores no escravo ou mestre nos pinos do conector DB9, sendo:",
  NO_POWER_SUPPLY_SUGGESTION_3: "No caso de terminador ativo, basta alimentá-lo, mas no caso de conector DB9 é necessário verificar se o problema está no conector ou na alimentação proveniente do escravo ou mestre.",
  NO_POWER_SUPPLY_SUGGESTION_4: "Indica-se realizar estes procedimentos com a produção parada, uma vez que esta alteração pode derrubar a rede.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  HIGH_RESISTANCE_SUGGESTION_1: "Quando o sinal estiver atenuado sugere-se:",
  HIGH_RESISTANCE_SUGGESTION_2: "Verificar:",

  HIGH_RESISTANCE_SUGGESTION_3: "Se algum equipamento do segmento está com terminador interno ligado;",
  HIGH_RESISTANCE_SUGGESTION_4: "Caso não tenha equipamento algum com terminador interno ligado verificar a eletrônica dos escravos, isolando individualmente do barramento;",
  HIGH_RESISTANCE_SUGGESTION_5: "Verificar se existem bornes frouxos nas conexões por borne ou conectores a borne;",
  HIGH_RESISTANCE_SUGGESTION_6: "Verificar mau contato em conectores do tipo “vampiro”;",
  HIGH_RESISTANCE_SUGGESTION_7: "Verificar se existem cabos amassados, o que aumentaria a resistência do cabo.",

  HIGH_RESISTANCE_SUGGESTION_8: "Esta verificação pode ser feita com a rede trabalhando, porém para qualquer intervenção indica-se esperar uma parada, pois estas alteração podem derrubar a rede.",

  // ---------------------------- A NOT OK ----------------------------
  A_NOT_OK_SUGGESTION_1: "Quando houver curto entra o condutor A e a malha sugere-se:",
  A_NOT_OK_SUGGESTION_2: "Realizar inspeção visual:",
  A_NOT_OK_SUGGESTION_3: "Interna dos conectores verificando se há curto entre o condutor A e a malha;",
  A_NOT_OK_SUGGESTION_4: "Por todo o segmento verificando se há algum trecho do cabo danificado prensado em eletrocalha ou cortado em saída de tubulação ou amassado por gaveta de CCM etc.",

  // ---------------------------- B NOT OK ----------------------------
  B_NOT_OK_SUGGESTION_1: "Quando houver curto entre o condutor B e a malha sugere-se:",
  B_NOT_OK_SUGGESTION_2: "Realizar inspeção visual:",
  B_NOT_OK_SUGGESTION_3: "Interna dos conectores verificando se há curto entre o condutor B e a malha;",
  B_NOT_OK_SUGGESTION_4: "Por todo o segmento verificando se há algum trecho do cabo danificado prensado em eletrocalha ou cortado em saída de tubulação ou amassado por gaveta de CCM etc.",

  // ---------------------------- LONG CABLE ----------------------------
  LONG_CABLE_SUGGESTION_1: "Quando o cabo for muito longo sugere-se:",
  LONG_CABLE_SUGGESTION_2: "Fazer uma inspeção visual do segmento e verificar se o barramento está longo demais para o baud rate (taxa de comunicação), segundo a tabela abaixo.",
  LONG_CABLE_SUGGESTION_3: "Caso o segmento esteja maior que o permitido sugere-se inserir um repetidor ou link de fibra óptica, dividindo o segmento.",

  BAUD_RATE_: "Baud rate",
  LENGTH: "Comprimento",
  NINE_SIX_KBITS: "9,6 kbit/s",
  NINETEEN_KBITS: "19,2 kbit/s",
  FORTY_FIVE_KBITS: "45,45 kbit/s",
  NINETY_THREE_KBITS: "93,75 kbit/s",
  HUN_EIGHTY_SEVEN_KBITS: "187,5 kbit/s",
  FIVE_HUNDRED_KBITS: "500,0 kbit/s",
  ONE_FIVE_KBITS: "1,5 Mbit/s",
  THREE_MBPS: "3,0 Mbit/s",
  SIX_MBPS: "6,0 Mbit/s",
  TWELVE_MBPS: "12,0 Mbit/s",

  // ---------------------------- NOISE ----------------------------
  NOISE_SUGGESTION_1: "Quando houver ruído ou baixa isolação (fuga para terra) sugere-se:",
  NOISE_SUGGESTION_2: "3 dicas tendem a ajudar a solucionar este problema:",
  NOISE_SUGGESTION_3: "Para atenuar o ruído é necessário verificar se todos os escravos da rede estão devidamente aterrados;",
  NOISE_SUGGESTION_4: "É necessário verificar a equipotencialização do sistema de aterramento, um modo simples é verificar se há corrente de fuga nos cabos PROFIBUS. Espera-se um valor abaixo de 100mA;",
  NOISE_SUGGESTION_5: "Verificar o isolamento das interfaces dos escravos, um modo simples é ir desconectando um a um os escravos do segmento e verificar no TS Scope se o problema persiste, ou seja, se na Live List os sinais se estabilizam em BOM).",
  NOISE_SUGGESTION_6: "Caso o problema persista após estas dicas indicamos procurar um especialista em redes PROFIBUS.",

  // ---------------------------- REFLECTION ----------------------------
  REFLECTION_SUGGESTION_1: "Quando houver reflexão na forma de onda sugere-se:",
  REFLECTION_SUGGESTION_2: "Este evento está quase sempre associado a falta de terminação na rede, portanto deve-se verificar visualmente:",

  REFLECTION_SUGGESTION_3: "Se os terminadores em ambas as extremidades do segmento estão na posição “on”;",
  REFLECTION_SUGGESTION_4: "Se não forem utilizados conectores PROFIBUS, verificar se existe terminador ativo em ambas as extremidades;",
  REFLECTION_SUGGESTION_5: "Caso não exista terminador em uma das extremidades é necessário realizar a instalação.",

  REFLECTION_SUGGESTION_6: "No entanto, a reflexão também pode ser resultado de emenda no cabo, uso de bornes inadequados, cabos amassados, mudança de tipo de cabo, uso de emenda com M12 ou qualquer outra alteração no meio físico de comunicação.",
  REFLECTION_SUGGESTION_7: "Nestes casos, faz-se necessária uma inspeção visual detalhada no segmento de rede indicado.",

  VOLTAGE_: "Tensão",

  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "Quando for detectado link de fibra ótica com falha no nível de tensão sugere-se verificar visualmente:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "Sugere-se consultar o manual do fabricante do link de fibra para conferir o nível de tensão adequado.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "Quando for detectado link de fibra ótica com falha grave no nível de tensão sugere-se verificar visualmente:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "Sugere-se consultar o manual do fabricante do link de fibra para conferir o nível de tensão adequado.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_SUGGESTION_1: "Quando for detectado sinal de falha por relé do link de fibra ótica sugere-se verificar visualmente:",

  FIBER_SIGNAL_LOSS_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  // ---------------------------- EXPERT REPORT ----------------------------
  SAVE_ACTIONS_LIST: "Salvar lista de ações",
  ACTIONS_LIST_FILENAME_PART: "Lista de ações - TS Scope DP",

  TERMINATION_OFF_PAGE_TITLE: ". - Terminador na posição OFF",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminador sem alimentação",
  HIGH_RESISTANCE_PAGE_TITLE: ". - Sinal atenuado",
  A_NOT_OK_PAGE_TITLE: ". - Curto entra o condutor A e a malha",
  B_NOT_OK_PAGE_TITLE: ". - Curto entre o condutor B e a malha",
  LONG_CABLE_PAGE_TITLE: ". - Cabo longo",
  NOISE_PAGE_TITLE: ". - Ruído ou baixa isolação (fuga para terra)",
  REFLECTION_PAGE_TITLE: ". - Reflexão na forma de onda",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Link de fibra ótica – Falha no nível de tensão (Ação Requerida)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Link de fibra ótica – Falha no nível de tensão (Ação Urgente)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Link de fibra ótica – Falha por relé",

  TERMINATION_OFF_DOTS: ".............................................................................................................",
  NO_POWER_SUPPLY_DOTS: "....................................................................................................",
  HIGH_RESISTANCE_DOTS: "............................................................................................................................",
  A_NOT_OK_DOTS: "...........................................................................................",
  B_NOT_OK_DOTS: "...........................................................................................",
  LONG_CABLE_DOTS: "..................................................................................................................................",
  NOISE_DOTS: ".................................................................................",
  REFLECTION_DOTS: "......................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: "...................................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: "......................................................",
  FIBER_SIGNAL_LOSS_DOTS: "..................................................................................................",

  DISCLAIMER_EXPERT_DOTS: ".......................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: ".........................................................................................................................................",

  SUGGESTION: "Sugere-se",
  EVIDENCE: "Evidências",
  EVIDENCE_SINGULAR: "Evidência",
  EVIDENCE_DESCRIPTION: "Captura de evidência da não conformidade informada pelo TS Expert:",

  TERMINATION_OFF_PAGE_DESCRIPTION: "O TS Expert está indicando uma possível falta de terminador na rede.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "O TS Expert está indiciando uma possível falta de alimentação no terminador.",
  HIGH_RESISTANCE_PAGE_DESCRIPTION: "O TS Expert está indicando possível excesso de terminadores ou alta resistência no barramento PROFIBUS.",
  A_NOT_OK_PAGE_DESCRIPTION: "O TS Expert está indicando possível curto-circuito entre o condutor A e a malha de blindagem ou a massa aterrada de um painel ou escravo.",
  B_NOT_OK_PAGE_DESCRIPTION: "O TS Expert está indicando possível curto-circuito entre o condutor B e a malha de blindagem ou a massa aterrada de um painel ou escravo.",
  LONG_CABLE_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de barramento com comprimento maior do que o permitido.",
  NOISE_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de ruído na rede PROFIBUS.",
  REFLECTION_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de reflexão na forma de onda.",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha no nível de tensão.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha no nível de tensão.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha por relé",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configurações WLAN",
  CONNECTION_STATUS: "Estado da conexão",

  WLAN_ADAPTER_ON: "Ligado",
  WLAN_ADAPTER_OFF: "Desligado",

  IP_PLACEHODLER: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Força do sinal",
  FREQUENCY: "Frequência",
  CHANNEL: "Canal",
  QUALITY: "Qualidade",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Qualidade",

  TURNING_WLAN_OFF_WAITING: "Desligando o adaptador WLAN, por favor aguarde.",
  TURNING_WLAN_ON_WAITING: "Ligando o adaptador WLAN, por favor aguarde.",

  NETWORK: "Rede",
  NETWORK_NAME_1: "Nome da rede",
  SUBMASK: "Máscara",
  PASSWORD: "Senha",

  ALTER_SCOPE_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do TS Scope DP?",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica o estado do adaptador WLAN do TS Scope DP.",
  WLAN_STATUS_POPUP_2: "Caso ele esteja desligado não é possível alterar as configurações WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica se o TS Scope DP está conectado ou não à rede WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "Não é possível alterar as configurações enquanto o adaptador WLAN estiver desligado.",
  WLAN_CONFIG_POPUP_2: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o TS Scope DP por meio da rede cabeada.",
  WLAN_CONFIG_POPUP_3: "Ao alterar o IP / máscara, caso os campos apareçam em branco após a atualização isso é um forte indicativo de que:",
  WLAN_CONFIG_POPUP_4: "Já existe um outro dispositivo na rede com o mesmo IP;",
  WLAN_CONFIG_POPUP_5: "A máscara de rede é muito restrita e não comporta o IP que foi passado.",

  WLAN_ADAPTER_NOT_FOUND_1: "O TS Scope DP não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique se o adaptador está desconectado, ou com mau contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Caso o adaptador não esteja desconectado nem com mau contato, tente substituí-lo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Se nenhuma das opções anteriores solucionar o problema entre em contato com a Toledo e Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique pelo menos um dos campos para atualizar as configurações WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "As configurações de WLAN foram atualizadas com sucesso!",
  SEND_WLAN_CONFIG_WAITING: "Enviando as configurações, por favor aguarde. Isso pode levar cerca de um minuto.",
  LOADING_WAITING: "Carregando informações, por favor aguarde.",
  WLAN_INFO: "Informações WLAN",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o TS Scope DP ou o roteador WLAN.",

  // ---------------------------- Temperature Alert ----------------------------
  IDLE_SIZE: "Tamanho do idle",
  PACKET_SIZE: "Tamanho de pacote",

  SMALL: "Pequeno",
  MEDIUM: "Médio",
  BIG: "Grande",

  IDLE_SIZE_QUESTION_ICON_INFO: "O tamanho do idle diz respeito à quantidade de pontos considerados no começo da forma de onda da resposta do device. É possível configurar três tamanhos distintos:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Tamanho do idle padrão (Varia de acordo com o baud rate);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Aumenta o tamanho em 1 tempo de um bit;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Aumenta o tamanho em 2 tempos de um bit.",

  PACKET_SIZE_QUESTION_ICON_INFO: "O tamanho de pacote é a quantidade total de pontos que são capturados pelo TS Scope DP em um único pacote de dados. É possível configurar três tamanhos distintos:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Tamanho de pacote padrão (Varia de acordo com o baud rate);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Aumenta o tamanho de pacote em 100 pontos;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Aumenta o tamanho de pacote em 200 pontos.",

  IDLE_SIZE_WAITING: "Realizando procedimentos para alterar o tamanho do idle, por favor aguarde nesta tela até que eles terminem.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "O tamanho do idle foi alterado com sucesso",
  IDLE_SIZE_CHANGE_FAILURE: "Ocorreu um erro ao alterar o tamanho do idle.",

  PACKET_SIZE_WAITING: "Realizando procedimentos para alterar o tamanho do pacote, por favor aguarde nesta tela até que eles terminem.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "O tamanho de pacote foi alterado com sucesso",
  PACKET_SIZE_CHANGE_FAILURE: "Ocorreu um erro ao alterar o tamanho do pacote.",

  REASON_DP: "Motivo: ",

  // ---------------------------- Segment Devices ----------------------------
  CHECK_MASTER: "Verificar mestre",
  START_SEARCH_ERROR_MESSAGE: "Ocorreu um erro ao iniciar a busca de dispositivos. Por favor tente novamente.",
  SEARCH_FINISH_SUCCESS: "Busca por dispositivos finalizada com sucesso!",
  GET_DEVICES_LIST_ERROR: "Ocorreu um erro ao carregar a lista de dispositivos.",

  IN_SEGMENT: "Atualmente no segmento",
  POSSIBLY_IN_SEGMENT: "Identificado como pertencente",
  POSSIBLY_OUT_OF_SEGMENT: "Foi detectado que este dispositivo pode estar em outro segmento",

  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "As informações sobre os dispositivos do segmento foram enviadas com sucesso!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "Ocorreu um erro ao enviar as informações sobre os dispositivos do segmento.",

  SEARCH: "Buscar",
  SEARCH_POPUP_1: "Para utilizar o TS Scope DP pela primeira vez é recomendado selecionar quais dispositivos pertencem ao segmento.",
  SEARCH_POPUP_2: "Aperte o botão abaixo para que o TS Scope DP faça uma busca e encontre todos dispositivos alcançaveis na rede.",
  SEARCH_POPUP_3_1: "Após encontrar os dispositivos, o TS Scope DP os adicionará à lista de ",
  SEARCH_POPUP_3_2: "dispositivos disponíveis",
  SEARCH_POPUP_3_3: " ao lado. Os dispositivos disponíveis ",
  SEARCH_POPUP_3_4: "são todos aqueles encontrados, que pertencem ao segmento de rede atual, ou não.",
  SEARCH_POPUP_4_1: "A outra lista, de ",
  SEARCH_POPUP_4_2: "dispositivos selecionados",
  SEARCH_POPUP_4_3: ", é a lista que ",
  SEARCH_POPUP_4_4: "contém os dispositivos selecionados pelo usuário que ele tem certeza que estão no segmento de rede atual.",
  SEARCH_POPUP_4_5: " Inicialmente esta lista estará vazia.",
  SEARCH_POPUP_5: "Feito a busca, caberá ao usuário selecionar quais destes dispositivos realmente percentem ao segmento de rede, movendo eles da lista de dispositivos disponíveis para a lista de dispositivos selecionados.",
  SEARCH_POPUP_6_1: "OBS: ",
  SEARCH_POPUP_6_2: "Os mestres da rede são sempre monitorados pelo TS Scope DP, portanto não aparecem nesta página.",

  SAVE_POPUP_1_1: "Ao clicar no botão abaixo, os dispositivos que estiverem na lista ",
  SAVE_POPUP_1_2: "Dispositivos selecionados",
  SAVE_POPUP_1_3: " serão salvos.",
  SAVE_POPUP_2_1: "Ao realizar este procedimento, apenas os dispositivos da lista ",
  SAVE_POPUP_2_2: "Dispositivos selecionados",
  SAVE_POPUP_2_3: " serão monitorados pelo TS Scope DP, e ",
  SAVE_POPUP_2_4: "somente eles serão mostrados nas telas do TS Scope DP, como: Live List, Matriz, Osciloscópio, etc.",

  EXPLANATION: "Explicação",

  SAVE_POPUP_3: "Esta funcionalidade é importante para identificar os escravos pertencentes ao segmento de rede PROFIBUS. O que diminui o tempo de reposta uma vez que o sistema estará verificando os escravos pertinentes.",
  SAVE_POPUP_4: "Também é de grande valia para que aqueles que tenham menor conhecimento da rede não procurem o problema em um segmento errado.",

  AVAILABLE_DEVICES: "Dispositivos disponíveis",
  AVAILABLE_DEVICES_POPUP_1_1: "Esta lista contém todos os dispositivos que o TS Scope DP ",
  AVAILABLE_DEVICES_POPUP_1_2: "encontrou na rede.",
  AVAILABLE_DEVICES_POPUP_2: "O TS Scope DP sugere os dispositivos que ele acredita pertencerem ao segmento de rede atual, indicando eles como: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identificado como pertencente.",

  AVAILABLE_DEVICES_POPUP_3_1: "Clicar no botão ",
  AVAILABLE_DEVICES_POPUP_3_2: " move um dispositivo da lista de ",
  AVAILABLE_DEVICES_POPUP_3_3: "dispositivos disponíveis",
  AVAILABLE_DEVICES_POPUP_3_4: " para a lista de ",
  AVAILABLE_DEVICES_POPUP_3_5: "dispositivos selecionados",
  AVAILABLE_DEVICES_POPUP_3_6: ", indicando que ele pertence ao segmento atual da rede. Após mover os dispositivos é necessário clicar no botão ",
  AVAILABLE_DEVICES_POPUP_3_7: "Salvar",
  AVAILABLE_DEVICES_POPUP_3_8: " para gravar essas alterações.",

  AVAILABLE_DEVICES_POPUP_4_1: "OBS: ",
  AVAILABLE_DEVICES_POPUP_4_2: "Fica a cargo do usuário tomar a decisão final e decidir quais dispositivos realmente pertencem ao segmento.",

  LOADING_DEVICES: "Carregando dispositivos",

  MOVE_ALL: "Mover todos",

  SELECTED_DEVICES: "Dispositivos selecionados",

  SELECTED_DEVICES_POPUP_1_1: "Esta lista contém todos os dispositivos que o usuário marcou como ",
  SELECTED_DEVICES_POPUP_1_2: "pertencentes ao segmento de rede atual.",

  SELECTED_DEVICES_POPUP_2_1: "É importante ressaltar que após clicar no botão ",
  SELECTED_DEVICES_POPUP_2_2: "Salvar",
  SELECTED_DEVICES_POPUP_2_3: ", O TS Scope DP ",
  SELECTED_DEVICES_POPUP_2_4: "somente irá monitorar os dispositivos que estiverem na lista de dispositivos selecionados.",

  SELECTED_DEVICES_POPUP_3_1: "Isto significa que:",
  SELECTED_DEVICES_POPUP_3_2: " Os dispositivos que não estiverem nesta lista não serão mostrados nas tela de Live list, Matriz, Osciloscópio, Gráfico de barras, etc.",

  CONFIRM_SEARCH_START: "Tem certeza que deseja iniciar a busca?",

  CONFIRM_SEARCH_START_POPUP_1_1: "O procedimento de busca de dispositivos levará ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (cinco) minutos",
  CONFIRM_SEARCH_START_POPUP_1_3: " para ser completado.",

  CONFIRM_SEARCH_START_POPUP_2_1: " Durante a busca ",
  CONFIRM_SEARCH_START_POPUP_2_2: "diversos procedimentos internos do TS Scope DP serão reiniciados",
  CONFIRM_SEARCH_START_POPUP_2_3: ", e por esta razão, ele somente voltará a funcionar normalmente após a busca ser finalizada.",
  CONFIRM_SEARCH_START_POPUP_2_4: "OBS:",

  SEARCHING_DEVICES: "Buscando dispositivos.",
  PLEASE_STAY_IN_PAGE: "Por favor permaneça na página para acompanhar o progresso da busca.",

  SENDING_DEVICES_INFO: "Enviando informações sobre os dispositivos, aguarde.",

  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Canais ativos",
  ACTIVE_CHANNELS_POPUP_1: "Permite configurar quais canais do TS Scope DP estão ativos no momento (Quais canais serão utilizados).",
  ACTIVE_CHANNELS_POPUP_2: "É recomendado desativar todos os canais que não estiverem sendo utilizados no momento.",
  SAVING_ACTIVE_CHANNELS: "Salvando canais ativos, por favor aguarde.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "Os canais ativos foram salvos com sucesso!",
  SEND_ACTIVE_CHANNELS_ERROR: "Occoreu um erro ao salvar os canais ativos",
  CANT_TURN_ALL_CHANNELS_OFF: "Não é possível desativar todos os canais do TS Scope DP ao mesmo tempo.\n\nÉ necessário que ao menos um dos canais permaneça ativo.",

  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",
  CHANNEL_5: "Canal 5",

  // ---------------------------- CHANNELS TIME ----------------------------
  CHANNELS_TIME: "Intervalo de escuta dos canais",
  CHANNEL_TIME_PLACEHOLDER: "20",
  CHANNELS_TIME_POPUP_1: "Nesta seção é possível configurar de quantos em quantos minutos o TS Scope DP escutará a troca de dados em cada um dos canais.",
  CHANNELS_TIME_POPUP_2: "Somente são válidos intervalos entre os seguintes valores:",
  CHANNELS_TIME_POPUP_3: "O intervalo mínimo de escuta é de ",
  CHANNELS_TIME_POPUP_4: "O intervalo máximo de escuta é de ",
  CHANNELS_TIME_POPUP_5: "(1 hora).",

  CONFIGURE_CHANNELS_TIME_SUCCESS: "O intervalo de escuta dos canais foi configurado com sucesso!",
  CONFIGURE_CHANNELS_TIME_ERROR: "Ocorreu um erro ao enviar o intervalo de escuta dos canais.",
  ERROR_REASON: ".\nMotivo: ",

  ERROR_MSG_1: "O intervalo de escuta do",
  ERROR_MSG_2: "não é valido.",

  //
  DEVICE_CHANNELS_ON: "Ligada",
  DEVICE_CHANNELS_OFF: "Desligada",

  CHANNELS_AND_DEVICES: "Canais e dispositivos",
  DEVICE_CHANNELS_POPUP: "Nesta seção é possível configurar se o TS Scope DP irá descobrir automaticamente a qual canal cada dispositivo pertence, ou se o usuário deseja definir o canal de cada dispositivo manualmente.",

  MEASURE_UNIT: "min",
  MEASURE_UNIT_1: "minuto",
  MEASURE_UNIT_2: "minutos",

  // ---------------------------- DEVICE CHANNELS ----------------------------
  CHECK_MASTER_2: "Verificar mestre",
  CHECK_MASTER_POPUP: "Ao ligar a verificação do mestre, o TS Scope DP detectará automaticamente quem é o mestre deste segmento da rede.",

  CHANGE_MANUAL_SELECTION_QUESTION_1: "Alterar o estado da seleção de canais reiniciará os procedimentos internos do TS Scope DP. Esse procedimento pode levar até 3 minutos.",
  CHANGE_MANUAL_SELECTION_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",

  CHANGE_VERIFY_MASTER_QUESTION_1: "Alterar a verificação do mestre reiniciará os procedimentos internos do TS Scope DP. Esse procedimento pode levar até 3 minutos.",
  CHANGE_VERIFY_MASTER_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",

  CHANGE_DEVICES_CHANNEL_QUESTION_1: "Atualizar os canais dos dispositivos reiniciará os procedimentos internos do TS Scope DP. Esse procedimento pode levar até 3 minutos.",
  CHANGE_DEVICES_CHANNEL_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",

  MANUAL_CHANNEL_SELECTION: "Seleção manual de canais",
  MANUAL_CHANNEL_SELECTION_1: "Seleção manual",
  MANUAL_CHANNEL_SELECTION_2: "de canais",

  MANUAL_CHANNEL_SELECTION_POPUP_1: "Ao ligar a seleção manual, o usuário poderá escolher na tabela ao lado a qual canal cada dispositivo pertence.",
  MANUAL_CHANNEL_SELECTION_POPUP_2: "Ao desligar a seleção manual, o TS Scope DP tentará descobrir automaticamente a qual canal cada dispositivo pertence.",
  MANUAL_CHANNEL_SELECTION_POPUP_3: "A descoberta automática de canais só é 100% confiável caso o TS Hub da Toledo e Souza esteja sendo utilizado. Caso esteja utilizando outro hub é recomendado definir manualmente o canal de cada dispositivo.",

  ALTER_DEVICES_CHANNELS: "Atualizar canais dos dispositivos",

  WARNING: "Aviso",
  MANUAL_SELECTION_WARNING_MESSAGE: "Enquanto a seleção manual estiver desligada, as opções ao lado estarão inacessíveis.",
  RESTARTING_INTERNAL_PROCEDURES: "Reiniciando procedimentos internos, por favor aguarde.",
  SEND_CHANGES_FAILURE: "Ocorreu um erro ao enviar as alterações",

  DEVICES_PER_CHANNEL_POST_SUCCESS: "Os dispositivos e seus canais foram salvos com sucesso!",
  DEVICES_PER_CHANNEL_ON_POST_SUCCESS: "A seleção manual de dispositivos do canal foi alterada com sucesso!",
  VERIFY_MASTER_POST_SUCCESS: "A verificação do mestre foi alterada com sucesso!",

  DEVICES_PER_CHANNEL_POST_ERROR: "Ocorreu um erro ao enviar os dispositivos e canais.",
  DEVICES_PER_CHANNEL_ON_POST_ERROR: "Ocorreu um erro ao alterar a seleção manual de canais.",
  VERIFY_MASTER_POST_ERROR: "Ocorreu um erro ao alterar a verificação do mestre.",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Fibra Ótica",
  RELAY_STATUS: "Status do relé",
  RELAY_SIGNAL: "Sinal do relé",
  MIN: "Mínimo",
  MAX: "Máximo",
  FAULT: "Falha",
  OK: "OK",
  MIN_ANALOG_VALUE: "Valor mínimo analógico",
  MIN_LIMIT_NOT_VALID: "O valor mínimo analógico não é válido",
  STATUS: "Status",
  MAINTENANCE_URGENT: "Valor de Manutenção Urgente",
  MAINTENANCE_REQUIRED: "Valor de Manutenção Requerida",
  DIVERGENCE_MAINTENANCE_VALUE: "O Valor de manutenção requerida não pode ser menor que o de manutenção urgente!",
  INVALID_VALUE: "Valor Invalido",
  STR_LIMIT: "Até",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Português",
  ENGLISH: "Inglês",
  SPANISH: "Espanhol",
  GERMAN: "Alemão",
  UPDATING_LANGUAGE_WAITING: "Alterando idioma, aguarde um instante",
  UNABLE_TO_ALTER_LANGUAGE: "Não foi possivel alterar o idioma do programa.\n",

  UPDATES_SUCCESS: "Atualizações realizadas com sucesso",

  IP_ASSOCIATED_MONITOR: "IP do monitor associado: ",
  PHYS_MEDIUM: "Meio físico DP",
});